import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"

function useGetEvents() {
  return useQuery({
    queryKey: queryKeys.events.list({}).queryKey,
    queryFn: () =>
      client.get(`/events/admin/events`).then((response) => response.data),
  })
}
export default useGetEvents
